import Environment from "./Environment";

export const OVERLAY_STYLE = {
    position: "absolute",
    padding: "4px",
    top: "0",
    left: "0",
    height: "100%",
    width: "100%",
    background: "rgba(0, 0, 0, 0.75)",
    border: "1px solid black",
    boxSizing: "border-box",
    color: "white",
    fontFamily: "sans-serif",
    fontSize: "13px",
    overflow: "scroll",
    textAlign: "left",
    webkitFontSmoothing: "subpixel-antialiased"
};

const RED_STYLING = {
    height: "150px",
    "background-color": "red"
};

const RESET_STYLING = {
    height: "auto",
    "background-color": "transparent"
};

export const OVERLAY_CLASS = "ad-overlay";

interface OverlayArgs {
    content: string;
    adElement: HTMLElement;
    empty: boolean;
}

/**
 * @class Overlayer
 */
export default class Overlayer {

    /**
     * Overlays adElement with content string
     */
    static overlay({ content, adElement, empty }: OverlayArgs) {
        const overlayElement = document.createElement("div");
        const elementStyling = empty ? RED_STYLING : RESET_STYLING;

        overlayElement.setAttribute("class", OVERLAY_CLASS);

        if (Environment.getElementStyleAttribute(adElement, "position") === "static") {
            adElement.style.position = "relative";
        }

        overlayElement.innerHTML = content;
        adElement.appendChild(overlayElement);

        Object.assign(overlayElement.style, OVERLAY_STYLE);
        Object.assign(adElement.style, elementStyling);
    }

    /**
     * Clears out any existing overlays
     */
    static clearOverlays() {
        const overlays = document.getElementsByClassName(OVERLAY_CLASS);

        for (let i = overlays.length - 1; i >= 0; --i) {
            const overlay = overlays.item(i);

            // @ts-expect-error fix when not in Q4
            overlay.parentNode.removeChild(overlay);
        }
    }

}
